import { createUseStyles } from 'react-jss'

export const useStyle = createUseStyles({
  offersRow: {
    marginTop: 16
  },
  name: {
    width: 200
  },
  value: {
    '&:not(:first-child)': {
      marginTop: 16
    }
  },
  text: {
    minWidth: 100,
    textAlign: 'end'
  },
  textRow: {
    width: 232
  },
  textDays: {
    display: 'flex',
    justifyContent: 'center',
    width: 160
  },
  textDescription: {
    marginTop: 4,
    maxWidth: 264
  },
  textPrice: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: 88
  },
  '@media screen and (max-width: 480px)': {
    textDays: {
      width: 64
    },
    textDescription: {
      marginTop: 4,
      maxWidth: '100%'
    }
  }
})
